
const customCartBtn = {
  async updateQuantity(element, action) {
 
    const customAddCart = $(element).closest('.custom-addcart').eq(0);
    const isDisabled = customAddCart.attr('disabled');
    if (isDisabled) {
      return;
    }
    //actually this is product variant ID.
    let productId = customAddCart.data('product-id');
   
    let updatedQuantity = 0;
    customAddCart.find('.custom-addcart--quantity span').eq(0).html(`
    <img class='filter-black' src="//farm2.me/cdn/shop/t/91/assets/tail-spin.svg?v=155854126672268590061764901671"" />
    `)
   
    this.getQuantity(productId).then(async ({ quantity, cart }) => {
      let endVal;

      if (action === 'increment') {
        updatedQuantity = quantity + 1;
        this.addProduct(productId)
          .then(() => {
            this.updateCartView();
          })
          .catch((error) => {
            // Add error message and disable the button.
            customAddCart
              .closest('.custom-addcart__wrapper')
              .eq(0)
              .children('span.superscript')
              .text('Inventory Limit Reached.');
            customAddCart.closest('button').attr('disabled', true);
          });
        this.updateElementValue(customAddCart, updatedQuantity);

      } else if (action === 'decrement' && quantity > 0) {
    
        updatedQuantity = quantity - 1;
        this.updateProduct(productId, updatedQuantity).then(() => {
          this.updateCartView();
        });
        this.updateElementValue(customAddCart, updatedQuantity);
      }
    });

  },
  async getQuantity(productId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: '/cart.js',
        method: 'GET',
        dataType: 'json',
      }).done(function (data) {
        const product = data.items.find((item) => item.id === productId);

        const result = { quantity: null, cart: data };
        if (product) {
          result.quantity = product.quantity;
        }

        resolve(result);
      });
    });
  },

  async addProduct(productId) {
    console.log('product id', productId);
    const req = { items: [{ id: productId, quantity: 1 }] };
    return new Promise((resolve, reject) => {
      $.post('/cart/add.js', req)
        .done(function (result) {
          resolve(result);
        })
        .fail(function () {
          alert('error');
          reject({ error: 'Inventory Limit reached' });
        });
    });
  },
  /**
  updates quantity or removes from cart if quantity is 0
  */
  async updateProduct(productId, quantity) {
    if (quantity < 1) {
      quantity = 0;
    }
    const requestData = {
      updates: {
        [productId]: quantity,
      },
    };

    return new Promise((resolve, reject) => {
      $.ajax({
        url: '/cart/update.js',
        method: 'POST',
        dataType: 'json',
        data: requestData,
        success: function (result) {
          resolve(result);
        },
      });
    });
  },
  updateElementValue($customAddCart, quantity) {
    if (quantity < 1) {
      this.toggleBtnView($customAddCart, false);
    } else {
      this.toggleBtnView($customAddCart, true);
    }
   
    $customAddCart
      .find('.custom-addcart--quantity')
      .find('span.quantity')
      .text(quantity);
    return true;
  },

  async updateCartView() {
    const { cart } = await this.getQuantity();

    $('#CartCount')
      .html(
        `<span class="js-ajax-cart-counter" data-cart-count="">${cart.item_count}</span>`
      )
      .removeClass('hide');

    return cart.item_count;
  },
  populateProductCounters() {
   
    this.getQuantity().then(({ cart }) => {
      cart.items.forEach((item) => {
        const customAddCart = $(
          `.custom-addcart[data-product-id=${item.variant_id}]`
        );
      
        const counterEl = customAddCart
          .find('.custom-addcart-collapseable.cart-counter')
          .eq(0);
     
        this.toggleBtnView(customAddCart, true);

        counterEl.find('span.quantity').text(item.quantity);
      });
    });
  },
  toggleBtnView($customAddCartNode, showQuantity = false) {
    const counterEl = $customAddCartNode
      .children('.quantity-selector')
      .eq(0);
    const startBtnEl = $customAddCartNode
      .children('.custom-addtobag-btn')
      .eq(0);

    if (showQuantity) {
      counterEl.removeClass('w-0');

      startBtnEl.addClass('hidden');
    } else {
      startBtnEl.removeClass('hidden');
      counterEl.addClass('w-0');
    }
  },
  init() {
    if(!customCartBtn.loaded) {
  
      customCartBtn.populateProductCounters();
  
      $(document.body).on('click', '.custom-addcart--increment', function (event) {
        event.preventDefault();
        event.stopPropagation();
        customCartBtn.updateQuantity(this, 'increment');
      });
    
      $(document.body).on('click', '.custom-addcart--decrement', function (event) {
 
        event.preventDefault();
        event.stopPropagation();
        customCartBtn.updateQuantity(this, 'decrement');
      });
      $(document.body).on('click', '.custom-addtobag-btn', function (event) {
  
        event.preventDefault();
        event.stopPropagation();
        customCartBtn.updateQuantity(this, 'increment');
      });
      customCartBtn.loaded = true;
    }
  },
  loaded: false
};

// show the quantity of each item in the item cards
// globoFilterRenderCompleted only fires on collection pages? Why?
window.addEventListener('globoFilterRenderCompleted', function () {
 customCartBtn.init();
  
});

//hurray! this works!
window.addEventListener('load', function () {
  customCartBtn.init();
});
